<template>
    <div v-if="dataSource && dataSourceType === 'OutgoingDocument'"
        :key="document.id"
        class="p-relative"
    >

        <Toolbar v-on:toolbar-button-click="onToolbarClick" />

        <DocumentPanel 
            :document-info="dataSource.Data.Object" 
            :showFavoriteBtn="isFavoriteBtnVisible && isViewMode && isRegistered"
            :favoriteValue="favoriteValue"
            :favorite-click-handler="() => this.onFavoriteClick({ documentId: this.document?.id })"
        />

        <div class="d-flex after-tabs-part-wrapper">

            <v-tabs
                v-model="tab"
                background-color="transparent"
                slider-size="3"
                class="tab-selector-panel"
                mobile-breakpoint="0"
            >
                <v-tabs-slider color="#E43958"></v-tabs-slider>

                <v-tab
                    v-for="item in pages"
                    :key="document.id + item.FormId"
                    @click="onTabClicked(item.FormId)"
                >
                    <template v-if="item.Count < 0">
                        {{ $t(item.Name) }}
                    </template> 
                    <template v-else>
                        {{ $t(item.Name) }}
                        <span class="count" id="attachCounter">{{item.Count}}</span>
                    </template>   
                </v-tab>

            </v-tabs>

            <div
                v-if="isViewMode && document.Version && (document.RegState === 0 || document.RegState === 3 || document.RegState === 5 || document.RegState === 6)"
                class="after-tabs-part"
            >
                <v-doc-version-chip :id="document.id" :text="$t('Версии')" />
            </div>

        </div>

        <v-tabs-items
            v-model="tab"
            class="tab-content-panel"
        >
            <v-tab-item 
                v-for="item in pages"
                :key="document.id + item.FormId"
            >
                <template v-if="item.FormId == document.id">
                    <v-form class="wrapperForm" ref="form" lazy-validation>
                        <v-row dense>
                            <!--Обертка для секции-->
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">

                                <!--Секция Сведения о регистрации-->
                                <v-card flat v-if="isRegistered">
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Сведения_о_регистрации")}}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Журнал_регистрации")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ document.Counter ? document.Counter.Name : '' }}</div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Исходящий_номер,_дата")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ concatedRegistrationData  }}</div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Регистратор")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-workplace-chip :id="document.Card.RegistratorWorkplaceId" :name="document.Card.RegistratorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <!--Обертка для блока-->
                                <v-card flat>
                                    <!--Обертка для контента блока Реквизиты документа-->
                                    <v-card-text>
                                        <!--заголовок блока-->
                                        <div class="form-box-title">{{$t("Реквизиты_документа")}}</div>

                                        <!--поле Номер проекта (всегда просмотр)-->
                                        <v-row no-gutters v-if="!document.is_new_record">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номер_проекта")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ document.Card.DraftNumber }}</div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Инициативный-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Инициативный")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.IsInitiative ? $t("Да") : $t("Нет") }}
                                                </div>
                                                <v-switch
                                                    v-else
                                                    :input-value="document.Card.IsInitiative"
                                                    @change="onIsInitiativeChange($event)"
                                                    inset
                                                    hide-details
                                                    class="cust-switch"
                                                />
                                            </v-col>
                                        </v-row>
                                        
                                        <!--поле Номенклатура-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Номенклатура")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : $t("не_указано")}}
                                                </div>
                                                <!-- <template v-else>
                                                    <div class="icon-click-row-group">
                                                        <div @click="onNomenclatureSelect">
                                                            <v-icon small v-tooltip.left-center="selectNomenclatureTooltip">
                                                                fas fa-edit
                                                            </v-icon>
                                                        </div>
                                                        <v-textarea
                                                            class="oneRowStartTextarea"
                                                            rows="1"
                                                            auto-grow
                                                            row-height="16"
                                                            no-resize
                                                            hide-details
                                                            required
                                                            outlined
                                                            dense
                                                            readonly
                                                            :value="document.Nomenclature ? `${document.Nomenclature.Code} ${document.Nomenclature.Header}` : ''"
                                                            :rules="requiredRule"
                                                        >
                                                        </v-textarea>
                                                    </div>
                                                </template> -->
                                                <v-select
                                                    v-else
                                                    :value="document.NomenclatureId != guidEmpty ? document.NomenclatureId : null"
                                                    @input="onNomenclatureInput($event)"
                                                    :items="nomenclatures"
                                                    :item-text="item => `${item.Code} ${item.Header}`"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="nomenclatureSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Вид документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Тип_документа") }}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.DocumentType ? document.Card.DocumentType.Value : $t("не_указано")}}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.DocumentType"
                                                    @input="update({ property: 'Data.Object.Document.Card.DocumentType', value: $event})"
                                                    :items="documentTypeItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="documentTypeSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Характер вопроса-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Характер_вопроса")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Card.QuestCharacter ? document.Card.QuestCharacter.Value : $t("не_указано") }}
                                                </div>
                                                <v-select
                                                    v-else
                                                    :value="document.Card.QuestCharacter"
                                                    @input="update({ property: 'Data.Object.Document.Card.QuestCharacter', value: $event })"
                                                    :items="questCharacterItems"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    outlined
                                                    dense
                                                    append-icon="fas fa-chevron-down"
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                >
                                                    <template v-slot:prepend-item>
                                                        <v-list-item>
                                                            <v-list-item-content>
                                                                <v-text-field 
                                                                    :placeholder="$t('Поиск')"
                                                                    class="mb-2 autocomplete-search"
                                                                    hide-details
                                                                    dense
                                                                    clearable
                                                                    autofocus
                                                                    v-model="questCharacterSearch"
                                                                >
                                                                </v-text-field>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                        </v-row>

                                        <!--поле Язык документа-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Язык_документа")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.Languages ? documentLanguages.map((x) => x.Value).join(', ') : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    v-model="documentLanguages"
                                                    :items="GetReference(1000)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    multiple
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="multipleRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <!--поле Тип носителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Тип_носителя")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.CarrierType ? document.Card.CarrierType.Value : $t("не_указано")}}
                                                </div>
                                                <v-autocomplete
                                                    v-else
                                                    :value="document.Card.CarrierType"
                                                    @input="update({ property: 'Data.Object.Document.Card.CarrierType', value: $event})"
                                                    :items="GetReference(1024)"
                                                    :item-text="item => $refLocale(item, $i18n.locale)"
                                                    item-value="id"
                                                    return-object
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                    append-icon="fas fa-chevron-down"
                                                >
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        
                                        <!--поле Количество ЛПЭ-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{ $t("Количество_листов/приложений") }}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{`${document.Card.ListCount}/${document.Card.AttachCount}`}}
                                                </div>
                                                <div class="more-inputs-in-row" v-else>
                                                    <v-text-field
                                                        :value="document.Card.ListCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.ListCount', value: $event})"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerNotNull"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                    <span>/</span>
                                                    <v-text-field
                                                        :value="document.Card.AttachCount"
                                                        @input="update({ property: 'Data.Object.Document.Card.AttachCount', value: $event})"
                                                        hide-details
                                                        required
                                                        outlined
                                                        dense
                                                        type="number"
                                                        :rules="integerRule.concat(requiredRule)"
                                                        class="cust-inputnumber"
                                                        min="0"
                                                    >
                                                    </v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                            </v-col>
                            
                            <v-col cols="12" sm="12" md="6" class="section-wrapper">

                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Исполнитель/Автор_документа") }}</div>

                                        <!--поле Исполнитель-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Исполнитель")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="icon-click-row-group icrg-align-center">
                                                    <div v-if="!isViewMode" @click="onExecuterSelect">
                                                        <v-icon small v-tooltip.left-center="selectExecuterTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div class="onlyReadData">
                                                        <v-workplace-chip
                                                            v-if="document.Card.ExecuterName"
                                                            :id="document.Card.ExecuterWorkplaceId"
                                                            :name="document.Card.ExecuterName"
                                                            :canDelete="!isViewMode"
                                                            :delFunc="onRemoveExecuter"
                                                        />
                                                        <template v-else>
                                                            <div v-if="!isViewMode" class="chipAreaNoData d-flex align-center pl-1">
                                                                <v-select-members-chip
                                                                    target-type="Member"
                                                                    @on-select="onSelectExecuterChip"
                                                                    :items-params="membersExecuterSelectParams"
                                                                    :required="true"
                                                                />
                                                            </div>
                                                            <template v-else>
                                                                {{ $t("Не_указано") }}
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <!--поле Телефон исполнителя-->
                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Телефон_исполнителя")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{document.Card.Phone ? document.Card.Phone : $t("не_указано")}}
                                                </div>
                                                <v-text-field
                                                    v-else
                                                    :value="document.Card.Phone"
                                                    @input="update({ property: 'Data.Object.Document.Card.Phone', value: $event})"
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters v-if="document.Card.SignerName">
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Подписант")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-workplace-chip :id="document.Card.SignerWorkplaceId" :name="document.Card.SignerName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>

                                <v-card flat v-if="isViewMode">
                                    <v-card-text>
                                        <div class="form-box-title">{{ $t("Кем_создано") }}</div>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Сотрудник")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">
                                                    <v-employee-chip :id="document.AuthorId" :name="document.AuthorName" />
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row no-gutters>
                                            <v-col cols="12" sm="12" md="4">
                                                <label class="f-label">{{$t("Дата_создания")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="8">
                                                <div class="onlyReadData">{{ formatDate(document.CreateDate) }}</div>
                                            </v-col>
                                        </v-row>
                                    
                                    </v-card-text>
                                </v-card>

                            </v-col>

                            <v-col cols="12" sm="12" md="12" class="section-wrapper">

                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Краткое_содержание")}}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Краткое_содержание")}}</label>
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="10">
                                                <div v-if="isViewMode" class="onlyReadData">
                                                    {{ document.Theme }}
                                                </div>
                                                <v-textarea v-else
                                                    :value="document.Theme"
                                                    @input="update({ property: 'Data.Object.Document.Theme', value: $event})"
                                                    rows="3"
                                                    no-resize
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    :rules="requiredRule"
                                                >
                                                </v-textarea>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>
                                
                                <v-card flat>
                                    <v-card-text>
                                        <div class="form-box-title">{{$t("Кому_адресовано")}}</div>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Получатели_в_эл_виде")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div class="icon-click-row-group">                                                    
                                                    <!-- Кнопка для стандартного выбора получателей через модалку -->
                                                    <div 
                                                        v-if="!isViewMode"
                                                        @click="onRecipientsSelect"
                                                    >
                                                        <v-icon small v-tooltip.left-center="selectRecipientsTooltip">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div
                                                        v-if="document.Card.Recipients.length == 0"
                                                        class="chipAreaNoData d-flex align-center pl-1" 
                                                    >
                                                        <v-select-members-chip 
                                                            v-if="!isViewMode"
                                                            target-type="Recipient"
                                                            @on-select="onSelectRecipientFromChip"
                                                            :items-params="recipientsSelectParams"
                                                            :required="true"
                                                        />
                                                    </div>
                                                    <div v-else class="onlyReadData more-per-lab-wrap">
                                                        <!-- Рисуем получателей -->
                                                        <template v-for="recipient in electronicFormRecipient">
                                                            <v-enterprise-chip
                                                                v-if="recipient.ContractorType === 0"
                                                                :id="recipient.Id"
                                                                :key="recipient.Id"
                                                                :name="recipient.Name"
                                                                :is-esedo="recipient.IsEsedo"
                                                                :canDelete="!isViewMode"
                                                                :delFunc="onRecipientDelete"
                                                            />
                                                            <v-workplace-chip
                                                                v-else
                                                                :disable-info="true"
                                                                :id="recipient.Id"
                                                                :key="recipient.Id"
                                                                :name="recipient.Name"
                                                                :is-esedo="recipient.IsEsedo"
                                                                :canDelete="!isViewMode"
                                                                :delFunc="onRecipientDelete"
                                                            />
                                                        </template>
                                                        <!-- Новая кнопка добавления получателей -->
                                                        <v-select-members-chip
                                                            v-if="!isViewMode"
                                                            target-type="Recipient"
                                                            @on-select="onSelectRecipientFromChip"
                                                            :items-params="recipientsSelectParams"
                                                        />
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row class="full-width-row" no-gutters>
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Получатели_в_бум_виде")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div class="icon-click-row-group">
                                                    <!-- Кнопка для стандартного выбора получателей через модалку -->
                                                    <div 
                                                        v-if="!isViewMode"
                                                        @click="onCustomRecipientsSelect"
                                                    >
                                                        <v-icon small v-tooltip.left-center="$t('Добавить_получателей')">
                                                            fas fa-edit
                                                        </v-icon>
                                                    </div>
                                                    <div
                                                        v-if="document.Card.Recipients.length == 0"
                                                        class="chipAreaNoData d-flex align-center pl-1"
                                                    >
                                                    </div>
                                                    <div class="onlyReadData more-per-lab-wrap">
                                                        <template v-for="(recipient, i) in paperFormRecipients">
                                                            <v-chip
                                                                :key="i"
                                                                small
                                                                class="person-label immutable-text"
                                                                label
                                                            >
                                                                <div
                                                                    class="if-more-tooltip-chip"
                                                                    v-tooltip="{ content: recipient.Name }"
                                                                >
                                                                    <div>{{customRecipientNameFormatter(recipient.Name)}}</div>
                                                                </div>    
                                                                <div class="pl-actions-wrapper">
                                                                    <span
                                                                        v-if="!isViewMode"
                                                                        v-tooltip.top="$t('Удалить')"
                                                                        @click.stop="onCustomRecipientDelete(recipient.Name)"
                                                                    >
                                                                        <i class="fas fa-trash dark-gray-color"></i>
                                                                    </span>
                                                                </div>
                                                            </v-chip>
                                                        </template>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>

                                        <v-row class="full-width-row" no-gutters v-if="document.Card.EmailRecipients && document.Card.EmailRecipients.length > 0">
                                            <v-col cols="12" sm="12" md="2">
                                                <label class="f-label">{{$t("Получатели_по_электронной_почте")}}</label>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="10">
                                                <div class="onlyReadData more-per-lab-wrap">
                                                    <template v-for="(recipient, i) in document.Card.EmailRecipients">
                                                        <v-email-chip
                                                            :key="i"
                                                            :email_object="recipient"
                                                        >
                                                        </v-email-chip>
                                                    </template>
                                                </div>
                                            </v-col>
                                        </v-row>

                                    </v-card-text>
                                </v-card>                                
                                

                                <TakeNoteListCardPanel :lists="takeNoteLists" />

                            </v-col>
                        </v-row>
                    </v-form>
                </template>

                <template v-else-if="item.FormId == 'RouteParams'">
                    <RouteParamsTab
                        :isViewMode="isViewMode"
                        :readonly="dataSource.Data.Object.ProcessInfoReadOnly"
                    />
                </template>

                <template v-else>
                    <component                         
                        :is="$mapComponent(item.FormId)" 
                        :ref="item.FormId" 
                        :id="document.id"
                    />
                </template>

            </v-tab-item>

        </v-tabs-items>

        <CreateCustomRecipientDlg ref="CreateCustomRecipientDlgRef" />

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import i18n from '@/i18n';
import _ from 'lodash';
import sys from '@/services/system';
import Toolbar from '@/components/documents/Toolbar.vue';
import DocumentPanel from '@/components/documents/DocumentPanel.vue';
import CreateCustomRecipientDlg from '@/components/documents/dialogs/CreateCustomRecipientDlg';
import RouteParamsTab from '@/components/documents/tabs/static/RouteParams';
import TakeNoteListCardPanel from '@/components/global/card/takenotelistcardpanel.vue';

export default {
    name: "OutgoingCard",
    components: {
        Toolbar,
        DocumentPanel,
        CreateCustomRecipientDlg,
        RouteParamsTab,
        TakeNoteListCardPanel
    },
    asyncComputed: {
        documentTypeItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1001 }));

                if (this.documentTypeSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.documentTypeSearch) || i.id == this.document?.Card?.DocumentType?.id);
                else
                    return items;
            },
            default: [],
            watch: ['documentTypeSearch']
        },
        questCharacterItems: {
            async get () {
                let items = Array.from(await this.$store.dispatch('documents/references/getReference', { id: 1003 }));

                if (this.questCharacterSearch)
                    return items.filter(i => sys.checkSearch(i.Value, this.questCharacterSearch) || i.id == this.document?.Card?.QuestCharacter?.id);
                else
                    return items;
            },
            default: [],
            watch: ['questCharacterSearch']
        },
        nomenclatures : {
            async get() {
                if (this.nomenclatureSearch) {                
                    return (await this.$store.dispatch('documents/references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }))
                        .filter(i => sys.checkSearch(`${i.Code} ${i.Header}`, this.nomenclatureSearch) || i.id == this.nomenclature?.id);
                }
                else
                    return (await this.$store.dispatch('documents/references/getNomenclatures', { forDepartment: false }))
                        .map(x => ({ id: x[0], Code: x[1], Header: x[2] }));
            },
            default: [],
            watch: ['nomenclatureSearch']
        }
    },
    computed: {
        ...mapGetters('documents/references', ['GetReference']),
        ...mapGetters('global/actionsource', { dataSource: 'getDataSource', dataSourceType: 'getDataSourceType' }),
        ...mapGetters({ 
            requiredRule: 'getRequiredRule',
            multipleRule: 'getMultipleRule',
            integerRule: 'getIntegerRule',
            integerNotNull: 'getIntegerNotNullRule'
        }),
        ...mapGetters('documents/favorites', { favoriteValue: 'favoriteValue', isFavoriteBtnVisible: 'isFavoriteBtnVisible' }),
        recipientsSelectParams() {
            return {
                multiple: true,
                includeOuterEnterprises: true,
                includeJuridical: true,
                includePersons: true,
                selected: [ ...this.document?.Card?.Recipients?.filter(x => x.ContractorType != 2 && x.Id != "00000000-0000-0000-0000-000000000000")?.map(x => x.Id) ?? [] ]
            };
        },
        membersExecuterSelectParams() {
            return {
                includeInner: true,
                multiple: false,
                selected: [ this.document.Card.ExecuterWorkplaceId ]
            }
        },
        electronicFormRecipient() {
            return this.document?.Card?.Recipients?.filter(x => x.ContractorType != 2 && x.Id != "00000000-0000-0000-0000-000000000000") ?? [];
        },
        paperFormRecipients() {
            return this.document?.Card?.Recipients?.filter(x => x.ContractorType == 2 && x.Id == "00000000-0000-0000-0000-000000000000") ?? [];
        },
        documentLanguages: {
            get: function() {
                return this.document.Card.Languages?.data_list ?? [];
            },
            set: function(value) {
                if (this.document.Card.Languages != null)
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages.data_list', value });
                else
                    this.updateSource({ property: 'Data.Object.Document.Card.Languages', value: { data_list: value } });
            }
        },
        isViewMode() {
            return this.dataSource?.Data.FormId == "0201021";
        },
        document() {
            return this.dataSource?.Data.Object.Document;
        },
        pages() {
            let pages = 
            [
                { Count: -1, FormId: this.document?.id, Name: "Карточка" }
            ];
            
            if ((!this.isViewMode || this.document?.ProcessInfo != null) &&
                this.document?.RegState !== 1 &&
                !this.isBypassing)
            {
                pages.push({ Count: -1, FormId: "RouteParams", Name: "Маршрут" });
            }

            
            pages = pages.concat(this.dataSource?.Data?.Object?.Pages ?? []);
            //pages = pages.filter(x => x.FormId != "0202090");

            return pages;
        },
        isRegistered() {
            return this.document.RegState == 1 || this.document.RegState == 4; 
        },
        concatedRegistrationData() {
            let result = i18n.t("Не_указано");

            if (this.document.Card.RegNumber?.length)
                result = `№ ${this.document.Card.RegNumber}`;

            if (this.document.Card.RegDate)
                result += ` ${this.$t("от_время")} ${this.formatDate(this.document.Card.RegDate)} г.`;

            return result;
        },
        isBypassing() {
            return this.document?.NotDraft === true;
        },
        selectExecuterTooltip(){
            return i18n.t("Выбрать_исполнителя");
        },
        selectRecipientsTooltip(){
            return i18n.t("Выбрать_получателей");
        },
        selectNomenclatureTooltip(){
            return i18n.t("Выбрать_номенклатуру");
        },
        guidEmpty() {
            return sys.guidEmpty();
        },
        takeNoteLists(){
            return this.document?.TaskLists?.filter(l => l.TaskType == 1) ?? [];
        }
    },
    data() {
        return {
            tab: null,
            questCharacterSearch: "",
            documentTypeSearch: "",
            nomenclatureSearch: ""
        }
    },
    methods: 
    {      
        ...mapActions('global/actionsource', { updateSource: 'updateDataSource' }),
        ...mapActions('documents/favorites',{ setFavoritesDefaults: 'setFavoritesDefaults', getFavoriteStatus: 'getFavoriteStatus', onFavoriteClick: 'onFavoriteClick' }),
        onTabClicked (formId) {
            if (this.$refs[formId])
                this.$refs[formId][0]?.update();
            this.$store.commit('documents/documentPanel/SET_SHOW_ROUTEPARAM_TAB', formId=='RouteParams' && !this.isViewMode && !this.dataSource.Data.Object.ProcessInfoReadOnly);
        },
        async onToolbarClick (event, button) {
            let actions = Reflect.ownKeys(this.$store._actions).filter(i => i.includes('global/actionsource/')).map(i => {return i.split('/')[2]})
            
            if (actions.includes(button.Action)) {
                if(button.Action == 'Save' || button.Action == 'SaveAndClose'){
                    let validate_result = this.$refs.form[0].validate();
                    if(validate_result && this.document.Card.Recipients.length > 0){
                        await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});        
                    }else{
                        this.$notify.alert(i18n.t("Не_заполнены_обязательные_поля"));
                    }
                }
                else if (button.Action == "SendDocumentByEmail"){
                    try {
                        const createdRecipient = await this.$refs.CreateCustomRecipientDlgRef.open({toEmail: true});
                        await this.$store.dispatch(`global/actionsource/SendDocumentByEmail`, {email: createdRecipient.Name});
                    }
                    catch (ex) {
                        console.log(ex.message);
                    }
                }
                else
                {
                    await this.$store.dispatch(`global/actionsource/${button.Action}`, {event, button});
                }
            }
            else
                this.$notify.alert(`Действие_${button.Action}_не_реализовано.`);
        },
        formatDate (source) {
            return this.$moment(source).format('DD.MM.YYYY');
        },
        onIsInitiativeChange (value) {
            this.updateSource({ property: 'Data.Object.Document.Card.IsInitiative', value});
        },
        async onExecuterSelect() {
            try {
                let selectMemberParams =  { 
                    title: i18n.t("Выбор_исполнителя"),
                    includeInner: true,
                    multiple: false,
                    selected: [ this.document.Card.ExecuterWorkplaceId ]
                }
                let { workplaceId, employeeId, name, contacts } = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);                
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName',  value: name });
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId',  value: workplaceId });
                this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId',  value: employeeId });
                
                let phone = contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
                this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        onSelectExecuterChip(e) {
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: e.value.name });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: e.value.workplaceId });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: e.value.employeeId });
            let phone = e.value.contacts?.find(contact => { return contact.type === "phone"; }) ?? null;
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: phone?.value ?? null });
        },
        onRemoveExecuter() {
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterName', value: null });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterWorkplaceId', value: '00000000-0000-0000-0000-000000000000' });
            this.updateSource({ property: 'Data.Object.Document.Card.ExecuterId', value: '00000000-0000-0000-0000-000000000000' });                
            this.updateSource({ property: 'Data.Object.Document.Card.Phone', value: null });
        },
        async onRecipientsSelect () {
            try {
                let currSelectedIds = [ ...this.document?.Card?.Recipients?.filter(x => x.ContractorType != 2 && x.Id != "00000000-0000-0000-0000-000000000000")?.map(x => x.Id) ?? [] ];

                let selectMemberParams =  { 
                    title: i18n.t("Выбор_получателей"),
                    multiple: true,
                    includeOuterEnterprises: true,
                    includeJuridical: true,
                    includePersons: true,
                    includeExecutersGroups: true,
                    selected: currSelectedIds
                }

                let selected = await this.$store.dispatch('global/dialogs/selectMembersNew/open', selectMemberParams);
                let newRecipients = selected.reduce((acc, val) => {
                    if (currSelectedIds.findIndex(s => s == val.enterprise) < 0)
                        acc.push({ ContractorType: val.type, Id: val.enterprise, IsEmployee: false, Name: val.name, IsEsedo: val.esedoMember });

                    return acc;
                }, []);

                if (newRecipients.length == 0) return;

                let recipients = Array.from(JSON.parse(JSON.stringify(this.document?.Card?.Recipients ?? [])));
                recipients.push(...newRecipients);
                this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients });
            }
            catch (ex) {
                console.log(ex);
            }
        },
        onSelectRecipientFromChip(e) {
            let recipients = Array.from(JSON.parse(JSON.stringify(this.document?.Card?.Recipients ?? [])));
            recipients.push(e.value);
            this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients });
        },
        onRecipientDelete(id) {
            let recipients = Array.from(JSON.parse(JSON.stringify(this.document?.Card?.Recipients ?? [])));
            let index = recipients.findIndex(r => r.ContractorType != 2 && r.Id === id);
            
            if (index < 0 ) return;

            recipients.splice(index, 1);
            this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients });
        },
        async onCustomRecipientsSelect () {
            try {
                let createdRecipient = await this.$refs.CreateCustomRecipientDlgRef.open();
                let recipients = Array.from(JSON.parse(JSON.stringify(this.document?.Card?.Recipients ?? [])));
                recipients.push(createdRecipient);
                this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients });
            }
            catch (ex) {
                console.log(ex.message);
            }
        },
        onCustomRecipientDelete(recipientName) {
            let recipients = Array.from(JSON.parse(JSON.stringify(this.document?.Card?.Recipients ?? [])));
            let index = recipients.findIndex(r => r.ContractorType == 2 && r.Id == "00000000-0000-0000-0000-000000000000" && r.Name == recipientName);

            if (index < 0 ) return;

            recipients.splice(index, 1);
            this.updateSource({ property: 'Data.Object.Document.Card.Recipients', value: recipients });
        },
        customRecipientNameFormatter(recipientName) {
            if (recipientName?.length > 40)
                return `${recipientName.substring(0, 39)}...`;
            else
                return recipientName;
        },
        async onNomenclatureSelect (){
            try {
                let selected = await this.$store.dispatch('dialogs/selectNomenclature/open', null);
                this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: selected[1], Header: selected[2] } });
                this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: selected[0] });
            }
            catch (ex) {
                console.log(ex.message);
            }
        },        
        onNomenclatureInput(event) {
            this.updateSource({ property: 'Data.Object.Document.Nomenclature', value: { Code: event.Code, Header: event.Header } });
            this.updateSource({ property: 'Data.Object.Document.NomenclatureId', value: event.id });
        },
        update: _.debounce(function (object) {
            this.updateSource(object);
        }, 250)
    },
    async created() {    
        this.setFavoritesDefaults();    
        (async() => {
            while(typeof this.$refs.form === 'undefined')
                await new Promise(resolve => setTimeout(resolve, 100));

            this.$refs?.form?.[0]?.validate();
            this.getFavoriteStatus({ documentId: this.document?.id });
        })();
    },
    updated() {
        if (this.dataSource !== null) {
            this.$refs?.form?.[0]?.validate();
        }  
    },
    mounted() {      
        this.$store.commit('documents/documentPanel/SET_SHOW_ROUTEPARAM_TAB', false);  
        this.$eventBus.$on('set-active-tab', async ({ FormId }) => {
            let page = this.pages.find(x => x.FormId === FormId);

            if (page) {
                let targetIndex = this.pages.indexOf(page);

                if (this.tab != targetIndex)
                    this.tab = targetIndex;
                else
                    this.$eventBus.$emit('update-active-tab');
            }
        });
    },
    beforeDestroy() {
        this.$eventBus.$off('set-active-tab');
        this.$store.commit('documents/documentPanel/SET_SHOW_ROUTEPARAM_TAB', false);
    }
}
</script>